import { fg } from '@confluence/feature-gating';
import { getLogger } from '@confluence/logger';

import type { bylineMetrics } from './bylineMetrics.ts';

type Metrics = typeof bylineMetrics;
let loaded: Metrics | undefined;
let pending: Promise<Metrics | undefined> | undefined;

export const getLoadedBylineMetrics = (): Metrics | undefined => loaded;

// Effect/callback only. Share a single request across all byline collectors.
export const loadBylineMetrics = (): Promise<Metrics | undefined> => {
	if (!fg('confluence_byline_cls_telemetry')) return Promise.resolve(undefined);
	return (pending ??= import(/* webpackChunkName: "async-byline-metrics" */ './bylineMetrics.ts')
		.then(({ bylineMetrics: metrics }) => {
			loaded = metrics;
			return metrics;
		})
		.catch((error) => {
			getLogger('byline-metrics').warn`Failed to load byline telemetry: ${error}`;
			pending = undefined;
			return undefined;
		}));
};
